import config from "../config.json"

export default function getBundeslandData(bundesland) {
    let combineStats = config["bundeslaender"][bundesland]
    // combineStats["laubLoss"] = areaStatistics["Laub_lost"]
    // combineStats["nadelLoss"] = areaStatistics["Nadel_lost"]
    return combineStats
}